module.exports = __webpack_public_path__ + "img/동탄 네일.b966fbd2.png";